export default __webpack_public_path__ + "static/media/back_thin_gray.24969175.svg";